import {ROLE_OPTIONS, RoleOption, UserRole} from "../../enums/user-role.enum";

export function getRoleOptions(currentUserRole: UserRole | undefined): RoleOption[] {
    if(!currentUserRole) {
        return ROLE_OPTIONS;
    }

    if (currentUserRole === UserRole.CHIEF_INSPECTOR) {
        return ROLE_OPTIONS.filter(option =>
            [UserRole.CHIEF_INSPECTOR, UserRole.INSPECTOR].includes(option.value)
        );
    }

    return ROLE_OPTIONS;
}
